import { Spacing } from '@persona-id/design-tokens';
import { startCase } from 'lodash/fp';
import styled from 'styled-components';

import {
  PEPFilters,
  PEPFilterType,
} from 'dashboard/components/ReportResult/PoliticallyExposedPersonPersonaV2/PoliticallyExposedPersonPersonaV2';
import Button from 'design-system/components/Button';

const BarContainer = styled.div`
  display: flex;
  grid-gap: ${Spacing[2]};
`;

interface FilterBarProps {
  // TODO: Integrate Profile Reports filter types
  filterOptions: typeof PEPFilterType;
  filterState: Set<PEPFilters>;
  availableFilters: PEPFilters[];
  setFilterState: (types: Set<PEPFilters>) => void;
}
const FilterBar = ({
  filterOptions,
  filterState,
  setFilterState,
  availableFilters,
}: FilterBarProps) => {
  const toggleFilters = (newType: PEPFilters) => {
    // Handle the case where we set all
    if (newType === filterOptions.All) {
      setFilterState(new Set([filterOptions.All]));
      return;
    }

    const selectedFiltersCopy = new Set(filterState);

    if (filterState.has(newType) && filterState.size > 1) {
      selectedFiltersCopy.delete(newType);
    } else {
      selectedFiltersCopy.delete(filterOptions.All);
      selectedFiltersCopy.add(newType);
    }
    setFilterState(selectedFiltersCopy);
  };
  return (
    <BarContainer>
      {Object.keys(filterOptions)
        .filter((v) => isNaN(Number(v)))
        .map((filterKey) => {
          // Only include this filter option when it's populated with real content
          if (availableFilters.includes(filterOptions[filterKey as keyof typeof PEPFilterType])) {
            return (
              <Button
                key={`report__identity-filter-${filterKey}`}
                id={`report__identity-filter-${filterKey}`}
                variant={
                  filterState.has(filterOptions[filterKey as keyof typeof PEPFilterType])
                    ? 'primary'
                    : 'basic'
                }
                width='auto'
                size='sm'
                onClick={() =>
                  toggleFilters(filterOptions[filterKey as keyof typeof PEPFilterType])
                }
              >
                {startCase(filterKey)}
              </Button>
            );
          }
        })}
    </BarContainer>
  );
};

export default FilterBar;
